import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class SummaryFetchService {

  constructor(private fireStore : AngularFirestore) { }

  fetchData(towerName){
    return this.fireStore.collection(towerName).doc(towerName).get();
}

setData(towerName){
  return this.fireStore.collection(towerName).doc(towerName);
}

}
